$(document).ready(function () {

  // $.get("https://ipinfo.io", function(response) {
  //   if (response.country == "IN") {
  //        window.location.href = "https://in.soothingcrystals.com/";
  //   }
  // }, "jsonp");

  // $.getJSON("http://jsonip.com?callback=?", function (data) {
  //   if (data.country == "IN") {
  //     console.log(data);
  //     window.location.href = "https://in.soothingcrystals.com/";
  //   }
  // });

  if ($("#recently-viewed-products").is(":parent")) {
    $(".custom-recently-viewed").hide();
    $(
      "#shopify-section-template--16491921015007__16638545542ebc4471 .section--divider"
    ).css("border-width", "0px");
  }

  function instantBuy() {
    var $ = jQuery;

    var formParams = $("form.cart").serialize();
    $.ajax({
      url: "/cart/add",
      type: "post",
      data: formParams,
      success: function () {
        window.location.href = "/checkout";
      },
      error: function () {},
    });
  }

  //           $("#grid-product__link .custom-cart-btn").click(function(e) {
  //     var senderElement = e.target;
  //     // Check if sender is the <div> element e.g.
  //     // if($(e.target).is("div")) {
  //     window.location = url;
  //     return true;
  // });

  $("#recently-viewed-products .title").each(function (index, value) {
    $(this).html($(this).html().substring(0, 30)); // number of characters
  });
  $(".new-collection-switcher .collection-switcher__title").on(
    "click",
    function () {
      $("a#custom-view-all").attr("href", $(this).find("a").attr("href"));
    }
  );
  $(".product-tab label").on("click", function () {
    if ($(this).siblings("input").prop("checked")) {
      $(this).siblings("input").attr("checked", false);
    } else {
      $(this).siblings("input").attr("checked", true);
    }
    return false;
  });

  // readmore readless
  function AddReadMore() {
    //This limit you can set after how much characters you want to show Read More.
    var carLmt = 300;
    // Text to show when text is collapsed
    var readMoreTxt = " ...read more";
    // Text to show when text is expanded
    var readLessTxt = " read less";

    //Traverse all selectors with this class and manipulate HTML part to show Read More
    $(".add-read-more").each(function () {
      if ($(this).find(".first-section").length) return;

      var allstr = $(this).text();
      if (allstr.length > carLmt) {
        var firstSet = allstr.substring(0, carLmt);
        var secdHalf = allstr.substring(carLmt, allstr.length);
        var strtoadd =
          firstSet +
          "<span class='second-section'>" +
          secdHalf +
          "</span><span class='read-more'  title='Click to Show More'>" +
          readMoreTxt +
          "</span><span class='read-less' title='Click to Show Less'>" +
          readLessTxt +
          "</span>";
        $(this).html(strtoadd);
      }
    });

    //Read More and Read Less Click Event binding
    $(document).on("click", ".read-more,.read-less", function () {
      $(this)
        .closest(".add-read-more")
        .toggleClass("show-less-content show-more-content");
    });
  }

  AddReadMore();

  $(".custom-btn-container input").click(function () {
    $(".payment-buttons button[data-add-to-cart]").trigger("click");
  });
  $(".custom-btn-container .custom-buy-btn").click(function () {
    $(".shopify-payment-button .kqsiVA9Jf8LJAbxw8Bau").trigger("click");
  });
});

$(window).bind("load", function () {
  $(".variant-block input").change(function () {
    if (
      $(".custom-price-container span.price2").val() ==
      $(".custom-price-container span.hide-2").val()
    ) {
      $(this).prop("checked", true);
      $(this).attr("checked", "checked");
      // alert($(".custom-price-container span.price2").val());
      if ($(".custom-price-container span.price2").text() != "") {
        $(".hide-2").hide();
      }
    } else {
      // alert($(".custom-price-container span.price2").val());
      if ($(".custom-price-container span.price2").val() != "") {
        $(".hide-2").hide();
      }
      $(".price2").show();
    }
  });
});
